/**
 * Trello 546 C008 — `page_price` is the checkout-entry path the Plan /
 * PlanPrice card-select prefixes onto its CTA href (`${page_price}?id=...`)
 * and then assigns to `window.location.href`. /plan, /program and /flashdeals
 * get it from their Express route ("/plan/signin", "/program/signin",
 * "/flashdeals/signin", routes/landing-page-default.js), but /plan, /plan-v3
 * and /plan-v4 also read it straight from `?page_price`, so a crafted link
 * (`?page_price=javascript:...//`, `//evil.example`) ran script on, or left,
 * myfitsociety.com after one click on a package card.
 *
 * Only a same-site path is kept: one leading "/", then a letter or digit,
 * then letters, digits, ".", "_", "-" and "/" — no "//" or "/\" start, no
 * scheme, no query/hash, no whitespace or control characters. Anything else
 * returns null, which every caller already treats as "no override" (the
 * default link.mobile.login(...) href), exactly like an absent page_price.
 */
const SAFE_PAGE_PRICE_PATTERN = /^\/[A-Za-z0-9][A-Za-z0-9._/-]*$/;
const MAX_PAGE_PRICE_LENGTH = 200;

export const sanitizePagePrice = (value) => {
  if (typeof value !== "string" || value.length > MAX_PAGE_PRICE_LENGTH) {
    return null;
  }
  return SAFE_PAGE_PRICE_PATTERN.test(value) ? value : null;
};
